import { render, staticRenderFns } from "./changeTel.vue?vue&type=template&id=bf2a2df8&scoped=true"
import script from "./changeTel.vue?vue&type=script&lang=js"
export * from "./changeTel.vue?vue&type=script&lang=js"
import style0 from "./changeTel.vue?vue&type=style&index=0&id=bf2a2df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2a2df8",
  null
  
)

export default component.exports